export type ShellPosture = 'operate' | 'builder'

/** Top-level UX mode exposed in the header. */
export type ShellMode = 'run' | 'studio'

/**
 * Resolves the shell posture from the current pathname. Single source of
 * truth shared by AppShell, Sidebar and ContextProvider.
 *
 * Canonical prefixes (design/os-reorganisation-ecrans § 7, lot R4):
 * - /run/*    → operate
 * - /studio/* → builder (Agents, Applications and Organisation alike)
 * The former /operate/*, /build/* and /builder/* paths only redirect for one
 * release; they resolve to the same posture so the shell does not flicker.
 */
export const routePosture = (pathname: string): ShellPosture => {
  if (
    pathname.startsWith('/studio') ||
    pathname.startsWith('/compose') ||
    pathname.startsWith('/build')
  ) {
    return 'builder'
  }
  return 'operate'
}

/** Header toggle: Run vs Studio. */
export const shellModeFromPosture = (posture: ShellPosture): ShellMode =>
  posture === 'operate' ? 'run' : 'studio'

/** Run uses Application context; Studio scopes via sidebar tree. */
export const usesApplicationContext = (posture: ShellPosture): boolean =>
  posture === 'operate'
